import React, { ButtonHTMLAttributes } from "react";
import { Content } from './styles'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement>{
    title: string;
    disabled?: boolean;
}
export function ButtonDecline({ title,disabled =false, ...rest } : Props){
    return(
        <Content  { ...rest} disabled={disabled}>
                    {title}
        </Content>
    )
}